<div class="pageheader">
    <div class="page-title">
        <h1>Test Cases</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>

            <button [routerLink]="['/test-tool/create-test-case']" class="btn btn-link" *bizPermissionRequired="'TestTool_Action_TestCase_Create'">New test case <ep-svg-icon icon="plus"></ep-svg-icon></button>
        </div>
    </div>
</div>

<dx-data-grid biz-grid
    [selection]='{ mode: "none" }'        
    [dataSource]='testCases'
    [bizSetPaging]="false"
    [bizSetScrolling]="false"
    (onInitNewRow)="onInitNewRow()"
    (onRowInserted)="onRowInsertedOrUpdated($event)"
    (onRowUpdated)="onRowInsertedOrUpdated($event)"
    (onRowRemoving)="onRowRemoving($event)"
    (onEditorPreparing)="onEditorPreparing($event)"
    (onRowDblClick)="onRowDblClick($event)">

    <dxo-editing mode="row" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding" [allowDeleting]="allowDeleting">
        <dxo-texts confirmDeleteMessage="Deleting this test case will also delete all associated test runs. Continue deleting test case?"></dxo-texts>
    </dxo-editing>

    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxi-column dataField="Name" caption="Name" dataType="string" [allowFiltering]="true" [allowGrouping]="false">
        <dxi-validation-rule type="required"></dxi-validation-rule>
        <dxi-validation-rule type="async" [reevaluate]="false" message="Test case name is not available" [validationCallback]="nameValidation"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="Description" caption="Description" dataType="string" [allowFiltering]="true" [allowGrouping]="true"></dxi-column>
    <dxi-column dataField="PreRunValidationDescription" caption="Ready to run" dataType="string" cellTemplate="preRunValidationDescriptionTemplate" [allowFiltering]="true" [allowGrouping]="true"></dxi-column>
    <dxi-column biz-grid-date dataField="LastRunDate" caption="Last Run Date" [allowFiltering]="true" [allowGrouping]="true" [visible]="false"></dxi-column>
    <dxi-column dataField="LastRunStatus" caption="Last Run Status" dataType="string" [allowFiltering]="true" [allowGrouping]="true" [visible]="false"></dxi-column>
    <dxi-column dataField="LastRunComment" caption="Last Run Comment" dataType="string" [allowFiltering]="true" [allowGrouping]="true" [visible]="false"></dxi-column>
    <dxi-column biz-grid-user dataField="LastRunBy" caption="Last Run By" [allowFiltering]="true" [allowGrouping]="true" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(testCases, 'LastRunBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column dataField="NumberOfInterchanges" caption="Number Of Interchanges" dataType="number" [allowFiltering]="true" [allowGrouping]="true" [visible]="false"></dxi-column>

    <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="true">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(testCases, 'CreatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="true" format="dateTime"></dxi-column>
    <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="true">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(testCases, 'UpdatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

    <dxi-column type="buttons">
        <dxi-button text="Interchanges" hint="Edit Test Case Interchanges" [onClick]="editTestCaseInterchanges"> </dxi-button>
        <dxi-button name="edit"></dxi-button>
        <dxi-button name="delete"></dxi-button>
    </dxi-column>

    <div *dxTemplate="let cell of 'preRunValidationDescriptionTemplate'">
        <span [style.color]="cell.data.PreRunValidationDescription === 'Ready' ? 'darkseagreen' : 'indianred'">
            {{cell.data.PreRunValidationDescription}}
        </span>
    </div>
</dx-data-grid>
